import { Box, Item } from '@factorialco/deprecated-design-system'
import { EmployeeGroupFragment } from 'generated/resources/graphql'
import { keyBy } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import {
  A3InnuvaMapping,
  A3InnuvaWizardData,
} from 'modules/payroll_integrations_a3innuva/lib/types'

import { MappingTable } from './MappingTable'
import { upsertWorkplaceMappings } from './helpers'

interface WorkplaceEmployeeGroupFillerProps {
  data: A3InnuvaWizardData
  onMappingChanged: (mappings: A3InnuvaMapping[]) => void
  options: Item[]
  employeeGroups: EmployeeGroupFragment[]
  loading?: boolean
}

export const WorkplaceEmployeeGroupFiller = ({
  data,
  onMappingChanged,
  options,
  employeeGroups,
  loading,
}: WorkplaceEmployeeGroupFillerProps) => {
  const mappings = data.sources?.workplaces?.mappings ?? []
  const mappingsById = keyBy(mappings, 'factorial_id')

  const setFormValues = (value: Item, employeeGroup: EmployeeGroupFragment) => {
    const newMappings = upsertWorkplaceMappings(mappings, value, employeeGroup.id.toString())
    onMappingChanged(newMappings)
  }

  const findSelection = (employeeGroupId: string) => {
    const mapping = mappingsById[employeeGroupId]
    if (!mapping) return ''
    return options.find((option) => option.value === mapping.meta?.uuid)?.label || ''
  }

  return (
    <Box
      border={{
        all: {
          color: 'grey000White',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{ all: 'abs008' }}
    >
      <MappingTable
        title={i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.mapping_table.a3innuva_fields'
        )}
        items={employeeGroups}
        options={options}
        getItemId={(item) => item.id.toString()}
        getItemLabel={(item) => item.name}
        onSelect={setFormValues}
        findSelection={findSelection}
        loading={loading}
        customBorder={{
          left: { color: 'grey000White', width: 's1', style: 'solid' },
          right: { color: 'grey000White', width: 's1', style: 'solid' },
          bottom: { color: 'grey000White', width: 's1', style: 'solid' },
        }}
        selectPlaceholder={i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.workplace.legal_entity_code.select'
        )}
      />
    </Box>
  )
}
